export const SET_DATA = (state, value) => {
  state.type = value.body.type
  state.subtype = value.body.subtype
  state.ticketId = value.body.ticketId
  state.fichero = value.body.fichero
  state.url = value.url
}

export const SET_TYPE = (state, value) => {
  state.type = value
}

export const SET_SUBTYPE = (state, value) => {
  state.subtype = value
}

export const SET_TICKET = (state, value) => {
  state.ticketId = value
}

export const SET_FICHERO = (state, value) => {
  state.fichero = value
}

export const SET_URL = (state, value) => {
  state.url = value
}

export const SET_ERR = (state, value) => {
  state.err = value
}
